module.exports = __webpack_public_path__ + "img/name_logo.f4997816.png";